import { useEffect } from 'react'

export default function AppBootLoader({
  message = 'Loading application...',
  hideOnUnmount = false,
  ariaLabel = 'Loading application',
}) {
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.showRootLoader === 'function') {
      window.showRootLoader(message)
    }

    return () => {
      if (hideOnUnmount && typeof window !== 'undefined' && typeof window.hideRootLoader === 'function') {
        window.hideRootLoader()
      }
    }
  }, [message, hideOnUnmount])

  // Root loader UI lives in `index.html` as `#root-loader`.
  // This component only updates the status text without re-rendering the full loader UI.
  return <div aria-busy="true" aria-live="polite" aria-label={ariaLabel} />
}
